// This routine converts an object containing a field name and a list of comma separated field values into the Autotask API payload
export const getApiPayload = (objectField, apiField, object, filter, order, maxRecords = 0) => {
    const result = {}
    if (maxRecords > 0) {
        result.maxRecords = maxRecords
    }
    const lObject = JSON.parse(object)
    const csvList = lObject[objectField].split(',')
    if (csvList.length > 0) {
        const items = csvList.map(val => ({ op: 'eq', field: apiField, value: val }))
        result.filter = [{ op: 'or', items }]
    }
    if (filter && filter.length > 0) {
        const lFilter = JSON.parse(filter)
        if (lFilter && lFilter.length > 0) {
            result.filter = [...(result.filter || []), ...lFilter]
        }
    }
    if (order && order.length > 0) {
        const orderItems = typeof order === 'string' ? JSON.parse(order) : order
        result.Order = orderItems.map(item => ({ field: item.field, direction: item.direction }))
    }
    return JSON.stringify(result)
}